<template >
  <article class="accessIndex" v-if="loaded">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Cortesías enviadas
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="dialog=true"
              >
                Enviar nueva
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="pagination_query=false;filterInvitations(true);date_available=false;"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <div class="accessIndex__general_info states_conventions__container px-4 ml-1 pt-4 pb-2">
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot sended"></div>
            <p class="states_conventions__item--text">Enviadas</p>
          </div>
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot register"></div>
            <p class="states_conventions__item--text">Registradas</p>
          </div>
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot joined"></div>
            <p class="states_conventions__item--text">Ingresadas</p>
          </div>
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot expired"></div>
            <p class="states_conventions__item--text">Vencidas</p>
          </div>
        </div>
        <div class="accessIndex__access_items--date_container_generic px-4 ml-1 pt-4 pb-2">
          <app-date-picker v-if="date_available"
            @filterQuery="pagination_query=false;filterInvitations(false,$event);"></app-date-picker>
        </div>
        <section>
      <v-data-table
        :headers="headers"
        :items="invitations"
        hide-actions
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.correo }}</td>
          <td>{{ props.item.in_date }}</td>
          <td>{{ props.item.user }}</td>
          <td class="accessIndex__state_colors">
            <div class="accessIndex__state_colors--container">
              <div v-if="'USED||CREATED||READY_FOR_USE'.includes(props.item.state)"class="accessIndex__state_colors--green_color"></div>
              <div v-if="'USED||READY_FOR_USE'.includes(props.item.state)" class="accessIndex__state_colors--purple_color"></div>
              <div v-if="'USED'.includes(props.item.state)" class="accessIndex__state_colors--blue_color"></div>
              <div v-if="'EXPIRED'.includes(props.item.state)" class="accessIndex__state_colors--red_color"></div>
              <!-- <div class="accessIndex__state_colors--red_color"></div> -->
            </div>

          </td>
        </template>
      </v-data-table>
    </section>
    <div v-if="invitations.length>0&& pages > 1" class="accessIndex__pagination">
      <v-pagination  color="light-blue darken-3" v-model="pagination.page" :length="pages"></v-pagination>
      <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
      <label class="accessIndex__pagination--current_text" v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}</label>
      <label class="accessIndex__pagination--current_text" v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>

    </div>
    <!-- new invitation dialog -->
    <template>
      <v-dialog v-model="dialog" persistent max-width="424px">

      <v-card>
				<div class="invitation__new">
				  <div class="invitation__new--title">
					<p class="invitation__new_text--title">Enviar cortesía</p>
				  </div>
				  <div class="invitation__new--info_container">
            <p class="invitation__new_text--small_red" v-show="this.newemail!=''&&errors.any()" >
                              {{errors.has('email') ? 'El correo electrónico es inválido':''}}
                            </p>
					  <p class="invitation__new_text--small_gray">Cortesía diriga a</p>

					  <div class="invitation__new--email_container">

  						<input name="email" placeholder="Correo electrónico" v-validate="{required: true, regex:/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/}"  type="text" v-model="newemail">
  						<div @click="newEmailInCourtesy(errors.any())" class="invitation__buttons--default">
  							<p>AGREGAR</p>
  						</div>
					  </div>
					  <!--v-flex xs12>
						<v-text-field label="Correo electrónico" v-model="newemail" required></v-text-field>
					  </v-flex-->

					  <div>
						<v-chip  close v-for="(tag,index) in select"
							color="#E2E2EB" text-color="#353545" v-model="select[index]"
							>
						{{tag}}
						</v-chip>
					  </div>

					  <div class="invitation__new--date_container">
  						<div class="invitation__new--date_container_item">
  						  <p class="invitation__new_text--small_gray">Válida desde</p>
  						  <v-menu
  							v-model="menunew"
  							:nudge-bottom="10"
  							lazy
  							transition="scale-transition"
  							offset-y
  							full-width
  							min-width="290px"
  							>
  							<template v-slot:activator="{ on }">
  							  <div  @click="datePickerFirstClick2=true"  class="date_picker__selector--invitation" v-on="on" >
    								<p >{{datePickerFirstClick2?data.attributes.from:'DD/MM/AAAA'}}</p>
    								<img :src="menu ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
  							  </div>
  							</template>
  							<v-date-picker v-model="data.attributes.from" :min="new Date().toISOString().substr(0, 10)" no-title scrollable>
  							</v-date-picker>
  						  </v-menu>
  						</div>
  						<div class="invitation__new--date_container_item">
  						  <p class="invitation__new_text--small_gray">Válida hasta</p>
  						  <v-menu
  							v-model="menu2new"
  							:nudge-bottom="10"
  							lazy
  							transition="scale-transition"
  							offset-y
  							full-width
  							min-width="290px"
  							>
  							<template v-slot:activator="{ on }">
  							  <div @click="datePickerFirstClick2=true" class="date_picker__selector--invitation" v-on="on" >
    								<p >{{datePickerFirstClick2?data.attributes.until:'DD/MM/AAAA'}}</p>
    								<img :src="menu2 ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
  							  </div>
  							</template>
  							<v-date-picker :min="data.attributes.from" v-model="data.attributes.until" no-title scrollable>
  							</v-date-picker>
  						  </v-menu>
  						</div>
					  </div>
            <div class="invitation__new--date_container">
              <div class="invitation__new--date_container_item">
                <v-menu
                  ref="menu_init_picker"
                  :close-on-content-click="false"
                  v-model="show_init_time_picker"
                  :nudge-right="40"
                  :return-value.sync="data.attributes.init_hour"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="data.attributes.init_hour"
                    label="Desde"
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    v-model="data.attributes.init_hour"
                    @change="$refs.menu_init_picker.save(data.attributes.init_hour)"></v-time-picker>
                </v-menu>
                <!-- <p class="invitation__new_text--small_gray">Hora desde</p>
                <input type="time" v-model="data.attributes.init_hour" name="init_hour"> -->
              </div>
              <div class="invitation__new--date_container_item">
                <v-menu
                  ref="menu_finish_picker"
                  :close-on-content-click="false"
                  v-model="show_finish_time_picker"
                  :nudge-right="40"
                  :return-value.sync="data.attributes.finish_hour"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="data.attributes.finish_hour"
                    label="Hasta"
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    v-model="data.attributes.finish_hour"
                    @change="$refs.menu_finish_picker.save(data.attributes.finish_hour)"></v-time-picker>
                </v-menu>
                <!-- <p class="invitation__new_text--small_gray">Hora hasta</p>
                <input type="time" v-model="data.attributes.finish_hour" name="finish_hour"> -->
              </div>
            </div>
					  <div class="invitation__new--actions">
						  <p class="invitation__buttons--blue" @click=" createInvitation(); ">ENVIAR</p>
						  <p class="invitation__buttons--gray" @click="dialog=false; datePickerFirstClick2=false;">CANCELAR</p>

					  </div>
					</div>
				</div>
      </v-card>
          </v-dialog>
    </template>
      </div>
    </div>



  </article>
</template>

<script>
export default {
  data(){
    return{
      show_init_time_picker: false,
      show_finish_time_picker: false,
      saved_default_option:false,
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date("2019-12-31").toISOString().substr(0, 10),
      datenew: new Date().toISOString().substr(0, 10),
      date2new: new Date().toISOString().substr(0, 10),
      select: [],
      menu: false,
      menu2:false,
      menunew: false,
      menu2new:false,
      datePickerFirstClick:false,
      datePickerFirstClick2:false,
      pages:2,
      pagination: {page:1,rowsPerPage:24},
      invitations: [],
      loaded: false,
      newemail:'',
      headers: [
        {text:'Correo', value: 'correo'},
        {text:'Fecha disponible', value: 'in_date'},
        {text:'Enviada por', value: 'user'},
        {text:'Estado', value: 'state'}
      ],
      months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"],
	  data: {
        attributes: {
          user_id: this.getUserId(),
          from: new Date().toISOString().substr(0, 10),
          until: new Date().toISOString().substr(0, 10),
          init_hour:null,
          finish_hour: null,
          offset_time: new Date().getTimezoneOffset()
        },
        invited_users_attributes:[]
      }
    }
  },
   watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.filterInvitations(false);

       }

       }
    }
    ,
  methods:{
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    newEmailInCourtesy(email_error){
      if(this.newemail!=''&&!email_error){
        this.select.push(this.newemail);
        this.newemail='';
      }
    },
    dateFormat(datex){
        var sections=datex.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months[index];
        datex=sections.join(" ");
        return datex;
    },
    monthEarlier(){
      var datex=new Date();
      datex.setMonth(datex.getMonth() - 1);
      return datex.toISOString().substr(0, 10);
    },
    filterInvitations(defaultOption,dates){
      // alert("entró"+defaultOption+'query'+this.pagination_query);
      if(this.pagination_query){
        defaultOption=this.saved_default_option;
      }
      else{
        this.pagination.page=1;
      }
      this.saved_default_option=defaultOption;

      var initialDate=this.monthEarlier();
      var lastDate=new Date().toISOString().substr(0, 10);
      if(!defaultOption){

        var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' };
        if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
          this.datePickerFirstClick=true;
          this.date = this.modifyDateFormatToStatus(object.date_from);
          this.date2 = this.modifyDateFormatToStatus(object.date_to);
        }
        initialDate=this.date;
        lastDate=this.date2;
      }
      else{
        this.date= this.monthEarlier();
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
      }
      try {

        this.$http.get('invitations/index',{
          params:{
            type: 'courtesies',
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
            page:this.pagination.page
          },
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }
        ).then(function(response){
          this.invitations= [];
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          var temp=response.body.data;

          for (var i=0;i<temp.length;i++) {


            this.invitations.push({
              correo:temp[i].email,
              in_date:this.dateFormat(this.$moment(temp[i].date).format(" MM/DD/YYYY")),
              user:temp[i].user,
              state: temp[i].state
            })
          }
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          console.table(response.body.data)
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
	filterEmptyEmails (arr){
      return arr.filter(function(ele){return ele != false});
    },
	createInvitation(){
      let vm = this;
      this.data.invited_users_attributes = this.filterEmptyEmails(this.select);

      this.data.invited_users_attributes = [...new Set(vm.data.invited_users_attributes.map(item => item))].map(function(x){return {email: x}});
      // alert(JSON.stringify(this.data.invited_users_attributes));
      try {
        this.$http.post('invitations/create', {
          data: this.encrypt(this.data).toString()
        },
        {headers:{
          "X-Device-ID" : this.getDeviceId(),
          "Authorization" : 'Bearer ' + this.getUserToken()
        }}).then(function(response){
          this.datePickerFirstClick2=false;
          this.dialog=false;
          this.select= [];
          this.filterInvitations(true);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }

    }
  },
  mounted(){
    // this.pagination.page=1;
    this.date= this.monthEarlier();
    // this.pagination.rowsPerPage=24;
    this.filterInvitations(true);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invitations/Index.vue